import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {AuthGuardService} from './shared/services';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/authentication/login',
        pathMatch: 'full'
    },
    {
        path: 'panel',

        loadChildren: () => import('./entries/panel/panel.module')
            .then(m => m.PanelModule),

        canLoad: [AuthGuardService],
        canActivateChild: [AuthGuardService]
    },
    {
        path: 'authentication',

        loadChildren: () => import('./entries/authentication/authentication.module')
            .then(m => m.AuthenticationModule)
    },
    {
        path: '**',

        loadChildren: () => import('./entries/error/error.module')
            .then(m => m.ErrorModule)
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutingModule {
}
